import { SET_IS_SAVING_SELL_INQUIRY_FORM_DATA, SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA, SET_SELL_INQUIRY_FORM_RESPONSE_DATA, SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA } from './constants.js'

/**
 * Submit Sell Inquiry form data to server.
 */
export const submitSellInquiryFormData = function ({ dispatch, commit }, payload = {}) {
	commit(SET_IS_SAVING_SELL_INQUIRY_FORM_DATA, true)
	// form our api payload
	let apiPayload = payload
	apiPayload.apiEndpoint = 'sell'
	apiPayload.config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	}
	const formData = new FormData()
	formData.append('action', 'submit_form_data')
	Object.keys(payload.data).forEach((key) => {
		formData.append(key, payload.data[key])
	})
	apiPayload.postData = formData
	return dispatch('apiCall', apiPayload).then((response) => {
		commit(SET_IS_SAVING_SELL_INQUIRY_FORM_DATA, false)
		if (typeof response.data.payload !== 'undefined') {
			commit(SET_SELL_INQUIRY_FORM_RESPONSE_DATA, response.data.payload)
			return response.data.payload
		}
	})
}

/**
 * Submit Sell Inquiry form file data to server.
 */
export const submitSellInquiryFormFileData = function ({ dispatch, commit }, payload = {}) {
	commit(SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA, true)
	// form our api payload
	let apiPayload = payload
	apiPayload.apiEndpoint = 'sell'
	apiPayload.config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	}
	const formData = new FormData()
	formData.append('file', payload.data)
	formData.append('form_id', payload.formId)
	formData.append('action', 'submit_form_file')
	apiPayload.postData = formData
	return dispatch('apiCall', apiPayload).then((response) => {
		commit(SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA, false)
		if (typeof response.data.payload !== 'undefined') {
			commit(SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA, response.data.payload)
			return response.data.payload
		}
	})
}

/**
 * Delete Sell Inquiry form file data from server.
 */
export const deleteSellInquiryFormFileData = function ({ dispatch, commit }, payload = {}) {
	// form our api payload
	let apiPayload = payload
	apiPayload.apiEndpoint = 'sell'
	apiPayload.config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	}
	const formData = new FormData()
	formData.append('file_id', payload.fileId)
	formData.append('form_id', payload.formId)
	formData.append('action', 'delete_form_file')
	apiPayload.postData = formData
	return dispatch('apiCall', apiPayload).then((response) => {
		if (typeof response.data.payload !== 'undefined') {
			return response.data.payload
		}
	})
}
